import Image from "next/image";
import styles from "./tnpsc-group-ii-main-2022-test-series-paper-i.module.css"
//import Banner from "../../assets/images/upsc/aboutbnr.webp";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
import Head from "next/head";
import Link from "next/link";
const Tnpsc_Group2_Main_2022_Test_Series_Paper1 = () =>{
   
    return(
        <>

        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Group Ⅱ Main Test Paper Ⅱ | Hybrid Test Series Batch</title>
            <meta name="title" content="TNPSC Group Ⅱ Main Test Paper Ⅱ | Hybrid Test Series Batch" />
            <meta name="description" content="TNPSC Group Ⅱ Main Test Paper Ⅱ | TNPSC Test Series, Online and Offline for Regular and Weekend Batch Students is the Best in Tamil Nadu for Group Ⅱ Mains" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-ii-mains-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group Ⅱ Main Test Paper Ⅱ | Hybrid Test Series Batch" />
            <meta property="og:description" content="TNPSC Group Ⅱ Main Test Paper Ⅱ | TNPSC Test Series, Online and Offline for Regular and Weekend Batch Students is the Best in Tamil Nadu for Group Ⅱ Mains" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-ii-mains-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

        <Navbar title="tnpsc" />

        <div className="container">

            <div className="row">
            <div className="col pt-3 pt-md-5">
                <h1 className={`${styles.pagemaintitle}`}>TNPSC Group II Main 2022 Test Series Paper I</h1>
            </div>
            </div>

           {/* <div className="row">
            <div className="col pt-2 mb-3">
                <Image src={Banner} alt="tnpsc-group-ii-main-2022-test-series-paper-i banner" title="TNPSC Group II Main 2022 Test Series Paper I" className="img-fluid w-100" />
            </div>
            </div> */}

            <div className="row pt-2">
            <div className="col-md-9 col-12">
                <h2 className={`${styles.sectiontitle} mb-0`}>TNPSC Group II Main 2022 Test Series Paper I (Compulsory Paper)</h2>
            </div>
            </div>

        </div>

   {/* table     */}

   <div className="container">
    <div className="row pt-3 prelimstable">
        <div className="col">
          <div className={`${styles.tablescroll}`}>
                 <table class="table">
                     <thead class="table" style={{backgroundColor:"#818C98"}}>
                        <tr>
                            <td className={`${styles.tableheading}`}>Center<br/></td>
                            <td className={`${styles.tableheading}`}>Batch<br/></td>
                            <td className={`${styles.tableheading}`}>Fee<br/></td>
                            <td className={`${styles.tableheading}`}>Schedule<br/></td>
                            <td className={`${styles.tableheading}`}>Payment<br/></td>
                        </tr>
                 </thead>
                 <tbody>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Chennai - Anna Nagar<br/></td>
                            <td className={`${styles.tablepara}`}>Batch I<br/><p className={`${styles.tablepara}`}>- Admission Closed</p></td>
                            <td className={`${styles.tablepara}`}>₹7000 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            <td><Link href="/pdf/Tnpsc-Group2-Mains-2022-Test-Series-Paper1/anna-nagar/anna-nagar-Test-Paper1-2022.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                        </tr>

                        <tr>
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch II (Offline/Online)<br/><p className={`${styles.tablepara}`}>- Admission Open</p></td>
                            <td className={`${styles.tablepara}`}>₹7000 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            <td><Link href="/pdf/Tnpsc-Group2-Mains-2022-Test-Series-Paper1/anna-nagar/anna-nagar-Test-Paper2-2022.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                       
                        <tr>
                            <td className={`${styles.tablepara}`}>Chennai - Adyar<br/></td>
                            <td className={`${styles.tablepara}`}>Regular<br/><p className={`${styles.tablepara}`}>(Only Offline)</p></td>
                            <td className={`${styles.tablepara}`}>₹7000 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            <td><Link href="/pdf/Tnpsc-Group2-Mains-2022-Test-Series-Paper1/adyar/PAPER-1-TEST-ADYAR.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        
                        <tr>
                            <td className={`${styles.tablepara}`}>Trichy<br/></td>
                            <td className={`${styles.tablepara}`}>Regular<br/><p className={`${styles.tablepara}`}>(Only Offline)</p></td>
                            <td className={`${styles.tablepara}`}>₹7000 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            <td><Link href="/pdf/Tnpsc-Group2-Mains-2022-Test-Series-Paper1/trichy/Group-II-Mains-Paper-1_trichy_07062022.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr>
                            <td className={`${styles.tablepara}`}>Madurai<br/></td>
                            <td className={`${styles.tablepara}`}>Regular<br/><p className={`${styles.tablepara}`}>(Only Offline)</p></td>
                            <td className={`${styles.tablepara}`}>₹7000 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            <td><Link href="/pdf/Tnpsc-Group2-Mains-2022-Test-Series-Paper1/madurai/Group-II-Mains-Paper-1.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr>
                            <td className={`${styles.tablepara}`}>Salem<br/></td>
                            <td className={`${styles.tablepara}`}>Regular<br/><p className={`${styles.tablepara}`}>(Only Offline)</p></td>
                            <td className={`${styles.tablepara}`}>₹7000 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            <td><Link href="/" target="_blank" className={`${styles.paybill}`}></Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr>
                            <td className={`${styles.tablepara}`}>Thiruvarur<br/></td>
                            <td className={`${styles.tablepara}`}>Regular<br/><p className={`${styles.tablepara}`}>(Only Offline)</p></td>
                            <td className={`${styles.tablepara}`}>₹7000 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            {/* <td><Link href="/" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td> */}
                        </tr>

                        <tr>
                            <td className={`${styles.tablepara}`}>Coimbatore<br/></td>
                            <td className={`${styles.tablepara}`}>Regular<br/><p className={`${styles.tablepara}`}>(Only Offline)</p></td>
                            <td className={`${styles.tablepara}`}>₹7000 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            <td><Link href="/pdf/Tnpsc-Group2-Mains-2022-Test-Series-Paper1/coimbatore/Paper-1_cbe_07062022.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        

                        
                       
                    </tbody>
              </table>
        </div>
        </div>
    </div>
</div>

   
    
    <Interest />
    <Footer />

        </>
    )
}
export default Tnpsc_Group2_Main_2022_Test_Series_Paper1;
